import {sendLog} from "../common/SendLog";

export const handleContinueClick = (serverApi, title, setIsModalOpen, setError, setErrorSuccess, emailForSend) => {
    const docSessionCode = localStorage.getItem("doc_session_code");
    const appDebag = localStorage.getItem("app_debag");

    serverApi.setCode(docSessionCode, appDebag, emailForSend).then((response) => {
        sendLog(serverApi, title, 'Отправка кода', 'setCode', false, response);
        if (response.data.success) {
            setIsModalOpen(true);
        } else {
            const errorData = response?.data?.error;
            const errorMessages = Array.isArray(errorData) ? errorData :
                (errorData ? [String(errorData), 'Попробуйте снова'] : ['Не удалось отправить SMS', 'Попробуйте снова']);

            setError(errorMessages);
            setErrorSuccess(true);
            sendLog(serverApi, title, 'Отправка кода', 'setCode', true, response);
        }
    }).catch((error) => {
        setError(['Ошибка соединения', 'Проверьте интернет']);
        setErrorSuccess(true);
        sendLog(serverApi, title, 'Сетевая ошибка при отправке SMS.', 'setCode', true, error);
    });
};
